var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      staticClass: "sharing-details-popup",
      attrs: { title: "Compartilhamentos", active: _vm.isVisible },
      on: {
        "update:active": function($event) {
          _vm.isVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "sharing-content" }, [
        _vm.loadingShares
          ? _c("div", { staticClass: "status-row" }, [
              _vm._v(" Carregando compartilhamentos... ")
            ])
          : _c("div", [
              _vm.isOwner
                ? _c("div", { staticClass: "owner-indicator" }, [
                    _vm._v(" Você é o proprietário deste recurso. ")
                  ])
                : _vm._e(),
              _vm.sharesError
                ? _c("div", { staticClass: "status-row error" }, [
                    _vm._v(
                      " Ocorreu um erro ao carregar os compartilhamentos. "
                    )
                  ])
                : _vm.hasShares
                ? _c("div", { staticClass: "sharing-section" }, [
                    _vm.sharedUsers.length
                      ? _c("div", { staticClass: "sharing-block" }, [
                          _c("h4", { staticClass: "sharing-title" }, [
                            _vm._v("Usuários")
                          ]),
                          _c(
                            "ul",
                            { staticClass: "sharing-list" },
                            _vm._l(_vm.sharedUsers, function(user) {
                              return _c("li", { key: "user-" + user.id }, [
                                _c("span", { staticClass: "primary" }, [
                                  _vm._v(_vm._s(user.name))
                                ]),
                                _c("span", { staticClass: "secondary" }, [
                                  _vm._v("ID usuário: " + _vm._s(user.id))
                                ]),
                                user.email
                                  ? _c("span", { staticClass: "secondary" }, [
                                      _vm._v(_vm._s(user.email))
                                    ])
                                  : _vm._e(),
                                _vm.isCurrentUser(user)
                                  ? _c("span", { staticClass: "badge-self" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isOwner
                                            ? "Você (proprietário)"
                                            : "Você"
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            }),
                            0
                          )
                        ])
                      : _vm._e(),
                    _vm.sharedGroups.length
                      ? _c("div", { staticClass: "sharing-block" }, [
                          _c("h4", { staticClass: "sharing-title" }, [
                            _vm._v("Grupos")
                          ]),
                          _c(
                            "ul",
                            { staticClass: "sharing-list" },
                            _vm._l(_vm.sharedGroups, function(group) {
                              return _c("li", { key: "group-" + group.id }, [
                                _c("span", { staticClass: "primary" }, [
                                  _vm._v(
                                    _vm._s(group.display_name || group.name)
                                  )
                                ]),
                                _c("span", { staticClass: "secondary" }, [
                                  _vm._v("ID grupo: " + _vm._s(group.id))
                                ])
                              ])
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ])
                : _c("div", { staticClass: "status-row empty" }, [
                    _vm._v(
                      " Nenhum compartilhamento encontrado para este recurso. "
                    )
                  ])
            ])
      ]),
      _c(
        "div",
        { staticClass: "footer-dialog justify-end" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-secondary" },
              on: { click: _vm.close }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-1",
                attrs: { icon: "XIcon", size: "16" }
              }),
              _vm._v(" Fechar ")
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }